import { PropsWithChildren, useContext, useMemo } from 'react'
import styled, { CSSObject } from '@emotion/styled'
import { Card, Flex } from '@applyboard/crystal-ui'
import { up } from '../../utils'
import { useGetSchool } from '../../hooks'
import { Navigate } from 'react-router-dom'
import { Loading } from '../Loading'
import { ConfigContext } from '../../utils/ConfigProvider'

export function OnBoardingBox(props: PropsWithChildren) {
  const { isLoadingSchool, school } = useGetSchool()
  const { ui, school: spaSchool } = useContext(ConfigContext)

  const backgroundColor = ui?.signupBackgroundColour || '#F3F3F3'
  const signupLogoUrl = ui?.signupLogo?.['300x78'] ?? school?.attributes.logo ?? ''
  const schoolName = useMemo(
    () => school?.attributes.name || spaSchool?.name || '',
    [school?.attributes.name, spaSchool?.name],
  )

  if (!isLoadingSchool && !school) {
    return <Navigate to="/not-found" />
  }

  return (
    <PageContainer backgroundColor={backgroundColor}>
      <Flex align="center" grow={1} gap={20} py={{ xs: 12, sm: 20 }} direction="column">
        {isLoadingSchool ? (
          <Flex direction="column" justify="between">
            <Loading />
          </Flex>
        ) : (
          <>
            {signupLogoUrl ? (
              <>
                <Flex hideBelow="sm">
                  <img alt={schoolName} src={signupLogoUrl} width={304} />
                </Flex>
                <Flex hideAbove="sm">
                  <img alt={schoolName} src={signupLogoUrl} width={138} />
                </Flex>
              </>
            ) : null}
            <Box>
              <Card>{props.children}</Card>
            </Box>
          </>
        )}
      </Flex>
    </PageContainer>
  )
}

const PageContainer = styled.div<{ backgroundColor: string }>(({ backgroundColor }): CSSObject => ({
  backgroundColor,
  width: '100vw',
  minHeight: '100vh',
  display: 'flex',
  position: 'relative',
  paddingLeft: 55,
  paddingRight: 55,
  [up('sm')]: {
    paddingLeft: 15,
    paddingRight: 15,
  },
}))

const Box = styled.div(() => ({
  width: '100%',
  maxWidth: 600,
  '> section': {
    padding: '24px 8px',
  },
}))
